import * as React from "react";
import PropTypes from "prop-types";
import { alpha } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TextField from "@mui/material/TextField";
import TableHead from "@mui/material/TableHead";
import Autocomplete from "@mui/material/Autocomplete";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import DeleteIcon from "@mui/icons-material/Delete";
import { MoreVert as MoreVertIcon } from "@mui/icons-material";
import VerifiedIcon from "@mui/icons-material/Verified";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

import FilterListIcon from "@mui/icons-material/FilterList";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "../CommonComponent/Button";
import MuiButton from "@mui/material/Button";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { visuallyHidden } from "@mui/utils";
import { useState } from "react";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import DownloadIcon from "@mui/icons-material/Download";
import EditIcon from "@mui/icons-material/Edit";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import adminAlternative from "../../Assets/adminAlternative.png";

import useHttp from "../../Hooks/use-http";
import QrCode from "./QrCode";
import {
  FormControl,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Modal,
  Radio,
  RadioGroup,
  Select,
  Card,
  CardContent,
  Grid,
  useMediaQuery,
  useTheme,
  Chip,
  Divider,
} from "@mui/material";
import CorporateFilter from "../CommonComponent/CorporateFilter";
import SearchFilter from "../CommonComponent/SearchFilter";
import PortalTitle from "../CommonComponent/PortalTitle";
import DeleteDriver from "./DeleteDriver";
import { LocalHospitalTwoTone } from "@mui/icons-material";
import { toast } from "react-toastify";
import CommonTablePagination from "../CommonComponent/CommonTablePagination";
import ChangeVehicle from "./ChangeVehicle";
import { useNavigate } from "react-router-dom";
import { useHistory, useLocation } from "react-router-dom";
import PastDriverLocation from "./PastDriverLocation";
import CloseIcon from "@mui/icons-material/Close";
import CustomInfoIcon from "../CommonComponent/CustomInfoIcon";
import { PAGINATIONBASEVALUE } from "../../Constant";

let selectedDriversEmailId = [];
let corporatesData = [];

let opeationType = "";
function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array?.map((el, index) => [el, index]);
  stabilizedThis?.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis?.map((el) => el[0]);
}

const headCells = [
  {
    id: "DriverName",
    numeric: false,
    disablePadding: true,
    label: "Driver Name",
    width: "16%",
  },
  {
    id: "Partner",
    numeric: false,
    disablePadding: true,
    label: "Partner",
    width: "14%",
  },
  {
    id: "Vehicle",
    numeric: false,
    disablePadding: true,
    label: "Vehicle",
    width: "16%",
  },
  {
    id: "DriverType",
    numeric: false,
    disablePadding: true,
    label: "Driver Type",
    width: "10%",
  },
  {
    id: "versionCode",
    numeric: false,
    disablePadding: true,
    label: "App Details",
    width: "10%",
  },
  {
    id: "UniqueNumber",
    numeric: true,
    disablePadding: false,
    label: "QR Code",
    width: "8%",
  },
  {
    id: "Status",
    numeric: true,
    disablePadding: false,
    label: "Status",
    width: "8%",
  },
];

function EnhancedTableHead(props) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="none" style={{ width: "2%" }}>
          {props?.selectedCorporateDetails?.cpName &&
            props.driverType !== "all" && (
              <Checkbox
                color="primary"
                size="small"
                indeterminate={numSelected > 0 && numSelected < rowCount}
                checked={rowCount > 0 && numSelected === rowCount}
                onChange={onSelectAllClick}
                inputProps={{
                  "aria-label": "select all desserts",
                }}
              />
            )}
        </TableCell>
        {headCells?.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={"center"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={{ 
              fontWeight: "bold", 
              width: headCell?.width || "auto",
              fontSize: "0.855rem !important",
              padding: "8px 4px !important",
            }}
          >
            <TableSortLabel
              style={{ fontSize: "0.855rem" }}
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
        {localStorage.getItem("roleId") == "1" && (
          // !selectedCorporateDetails?.cpName && (
          <>
            <TableCell
              key="CpName"
              align={"center"}
              padding={"normal"}
              sortDirection={orderBy === "CpName" ? order : false}
              sx={{ 
                fontWeight: "bold", 
                width: "10%", 
                alignItems: "center",
                fontSize: "0.855rem !important",
                padding: "8px 4px !important",
              }}
            >
              <TableSortLabel
                active={orderBy === "CpName"}
                direction={orderBy === "CpName" ? order : "asc"}
                onClick={createSortHandler("CpName")}
                style={{ fontSize: "0.855rem" }}
              >
                {"Corporates"}

                {orderBy === "CpName" ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === "desc"
                      ? "sorted descending"
                      : "sorted ascending"}
                  </Box>
                ) : null}
              </TableSortLabel>
            </TableCell>
          </>
        )}
        {localStorage.getItem("roleId") == "1" && (
          <TableCell
            key="Actions"
            align="center"
            padding="normal"
            sx={{ 
              fontWeight: "bold",
              fontSize: "0.855rem !important",
              padding: "8px 4px !important",
              textAlign: "center",
            }}
          >
            Actions
          </TableCell>
        )}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

function EnhancedTableToolbar(props) {
  const {
    selected,
    visibleRows,
    setFilteredData,
    privateDrivers,
    setSelectedCorporateDetails,
    selectedCorporateDetails,
    corporateData,
    setCorporateData,
    statusFilter,
    setStatusFilter,
  } = props;
  const enabledModule = localStorage.getItem("enabledModule");
  const enabledModuleArr = enabledModule?.split(",");

  const [searchValue, setSearchValue] = useState("");

  const history = useHistory();

  const location = useLocation();

  React.useEffect(() => {
    if (location.state?.isApiCall) {
      // Call setIsApiCall or handle the logic accordingly
      props.setIsApiCall(); // Ensure props or context provides this function
    }
  }, [location.state, props]);

  return (
    <Toolbar
      sx={{
        display: "flex", // Set display to flex
        alignItems: "center", // Align items vertically center
        justifyContent: "space-between", // Space between items
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
        ...(selected?.length > 0 && {
          bgcolor: (theme) =>
            alpha(
              theme.palette.primary.main,
              theme.palette.action.activatedOpacity
            ),
        }),
      }}
    >
      {selected?.length > 0 ? (
        <Typography
          sx={{ flex: "1 1 100%" }}
          color="inherit"
          variant="subtitle1"
          component="div"
        >
          {selected?.length} selected
        </Typography>
      ) : (
        <div style={{ display: "flex", alignItems: "center" }}></div>
      )}

      <Box sx={{ display: "flex", alignItems: "flex-end", gap: 2, marginLeft: "auto", flexWrap: "wrap" }}>
        <FormControl
          variant="standard"
          sx={{ 
            minWidth: 150,
            marginBottom: "1px",
          }}
        >
          <Select
            value={statusFilter || "all"}
            onChange={(e) => {
              setStatusFilter(e.target.value);
              // Apply status filter
              let filtered = privateDrivers || [];
              if (e.target.value === "approved") {
                filtered = filtered.filter(
                  (driver) => driver.isApproved === 1 || driver.isApproved === true
                );
              } else if (e.target.value === "suspended") {
                filtered = filtered.filter(
                  (driver) => driver.isApproved === null || driver.isApproved === 0 || driver.isApproved === false
                );
              }
              // Apply search filter if exists
              if (searchValue) {
                const searchLower = searchValue.toLowerCase();
                filtered = filtered.filter(
                  (driver) =>
                    (driver.fName && driver.fName.toLowerCase().includes(searchLower)) ||
                    (driver.lName && driver.lName.toLowerCase().includes(searchLower)) ||
                    (driver.emailID && driver.emailID.toLowerCase().includes(searchLower)) ||
                    (driver.mobileNumber && driver.mobileNumber.includes(searchValue)) ||
                    (driver.corporates &&
                      driver.corporates.some((cp) =>
                        cp.name?.toLowerCase().includes(searchLower)
                      ))
                );
              }
              setFilteredData(filtered);
            }}
            displayEmpty
            sx={{ fontFamily: "Montserrat" }}
          >
            <MenuItem value="all">All Status</MenuItem>
            <MenuItem value="approved">Approved</MenuItem>
            <MenuItem value="suspended">Suspended</MenuItem>
          </Select>
        </FormControl>
        <Box sx={{ alignSelf: "center" }}>
          <SearchFilter
            data={privateDrivers}
            searchValue={searchValue}
            setSearchValue={setSearchValue}
            setFilteredData={(filtered) => {
              // Apply status filter along with search
              let result = filtered || [];
              if (statusFilter === "approved") {
                result = result.filter(
                  (driver) => driver.isApproved === 1 || driver.isApproved === true
                );
              } else if (statusFilter === "suspended") {
                result = result.filter(
                  (driver) => driver.isApproved === null || driver.isApproved === 0 || driver.isApproved === false
                );
              }
              setFilteredData(result);
            }}
            styling={{}}
            placeholder={"Driver / Corporate"}
          />
        </Box>
      </Box>
      {selected?.length > 0 ? (
        <Tooltip title="Delete">
          <IconButton>
            <DeleteIcon onClick={() => props.setIsDeleteDialogOpen(true)} />
          </IconButton>
        </Tooltip>
      ) : (
        <div style={{ display: "flex", alignItems: "center" }}></div>
      )}
    </Toolbar>
  );
}

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

export default function EditDriver({
  privateDrivers,
  selectedCorporateDetails,
  dataLoading,
  setIsApiCall,
  driverType,
  setDriverType,
  corporateNameClickHandler,
  filteredCorporates,
  setFilteredCorporates,
  setSelectedCorporateDetails,
  corporateData,
  setCorporateData,
  isApiCall,
  isAddDriverClicked = false,
  setIsAddDriverClicked,
}) {
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("DriverName");
  const [filteredData, setFilteredData] = useState(privateDrivers);

  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(PAGINATIONBASEVALUE);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);

  const [isAddDeletePrivateDrivesClicked, setIsAddDeletePrivateDriversClicked] =
    useState(false);
  const [
    isAddEditPrivateDriverOperationSuccess,
    setIsAddEditPrivateDriverOperationSuccess,
  ] = useState(false);
  // isAddDriverClicked is now passed as prop from parent
  const [allDriversList, setAllDriversList] = useState([]);
  const [openedDriverQr, setOpenedDriverQr] = useState();
  const [openDeleteModal, setDeleteModal] = useState(false);
  const [openChangeVehicleModal, setChangeVehicleModal] = useState(false);
  const [openDriverLocation, setOpenDriverLocation] = useState(false);

  const [selectCorporateOnDelete, setSelectCorporateOnDelete] = useState([]);
  const [selectedDriverType, setSelectedDriverType] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [driverData, setDriverData] = useState(null);
  const [changeVehicleDriverData, setChangeVehicleDriverData] = useState(null);
  const [driverEmailForLocation, setDriverEmailForLocation] = useState(null);
  const [statusFilter, setStatusFilter] = useState("all"); // "all", "approved", "suspended"

  const { sendRequest } = useHttp();

  const history = useHistory();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  // Delete Modal
  const handleOpenDeleteDriverModal = () => {
    setDeleteModal(true);
    setIsDeleteDialogOpen(true);
    setDriverData(driverData);
  };

  const handleCloseDeleteDriverModal = () => {
    setDeleteModal(false);
    // setDriverData(null);
  };

  // Change Vehicle Modal
  const handleOpenChangeVehicleModal = () => {
    // Just open the modal - driverData should already be set by handleMenuClick
    setChangeVehicleModal(true);
  };
  const handleOpenLocation = () => {
    setOpenDriverLocation(true);
  };
  const handleCloseLocation = () => {
    setOpenDriverLocation(false);
    // setDriverData(null);
    // setChangeVehicleDriverData(null)
  };

  const handleVerificationDocument = (row) => {
    history.push({
      pathname: "/verification-documents",
      state: { data: row },
    });
  };

  const handleCloseChangeVehicleModal = () => {
    setChangeVehicleModal(false);
    // setDriverData(null);
    // setChangeVehicleDriverData(null)
  };

  const addDeletePrivateDriverResponse = (data) => {
    const isSuccess = data.status === 200 || 201;
    setIsAddEditPrivateDriverOperationSuccess(isSuccess);

    if (isSuccess) {
      setIsApiCall(true);
      setIsDeleteDialogOpen(false);
      setIsAddDriverClicked(false);
      // toast.success(`Drivers have been ${opeationType === "add" ? "added" : "removed"} successfully`);
    }
    // else {
    //   toast.error("Some error occurred");
    // }

    setIsAddDeletePrivateDriversClicked(false);
    setSelected([]);
    selectedDriversEmailId = "";
  };

  const driverSelectHandler = (e, driverData) => {
    selectedDriversEmailId = driverData?.emailID;
    setDriverData(driverData);
  };

  const driverListDetails = (data) => {
    if (data?.drivers) {
      setAllDriversList(data?.drivers);
    }
  };
  React.useEffect(() => {
    if (isAddDriverClicked) {
      // setIsDeleteDialogOpen(false);
      sendRequest(
        {
          url: "/drivers",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: {
            emailID: localStorage.getItem("user"),
          },
        },
        driverListDetails
      );
    }
  }, [sendRequest, isAddDriverClicked]);

  // const allDepartmentIDs = selectedCorporateDetails?.[0]?.dpId?.split(",");
  const allDepartmentIDs = selectedCorporateDetails?.[0]?.dpId;

  const firstDepartmentID = allDepartmentIDs ? allDepartmentIDs[0] : "";
  React.useEffect(() => {
    let isMounted = true;
    
    if (isAddDeletePrivateDrivesClicked) {
      opeationType = isDeleteDialogOpen ? "delete" : "add";
      // opeationType = selectCorporateOnDelete ? "delete" : "add";

      const corporateID = isDeleteDialogOpen
        ? selectCorporateOnDelete?.[0]?.CorporateID ||
          selectedCorporateDetails?.[0]?.cpId ||
          "defaultCorporateID"
        : selectedCorporateDetails?.[0]?.cpId || "defaultCorporateID";

      const departmentID = isDeleteDialogOpen
        ? selectCorporateOnDelete?.[0]?.DepartmentID ||
          firstDepartmentID ||
          "defaultDepartmentID"
        : firstDepartmentID || "defaultDepartmentID";

      sendRequest(
        {
          // url: updateAddDriverButton,
          url: "/addcorporatedriver",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },

          body: {
            emailID: localStorage.getItem("user"),
            data: {
              emailID: driverData?.emailID,
              corporateID: selectedCorporateDetails?.[0]?.cpId,
              mobileNumber: driverData?.mobileNumber,
              types: driverType,
            },
          },
        },

        (data) => {
          if (isMounted) {
            addDeletePrivateDriverResponse(data);
          }
        }
      );
    }
    
    return () => {
      isMounted = false;
    };
  }, [sendRequest, isAddDeletePrivateDrivesClicked]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = privateDrivers?.map((n) => n.DriverEmailID);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected?.slice(1));
    } else if (selectedIndex === selected?.length - 1) {
      newSelected = newSelected.concat(selected?.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected?.slice(0, selectedIndex),
        selected?.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - filteredData?.length) : 0;

  const visibleRows = React.useMemo(
    () =>
      stableSort(filteredData, getComparator(order, orderBy))?.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
      ),
    [order, orderBy, page, rowsPerPage, filteredData]
  );

  const handleDriverTypeChange = (event) => {
    setDriverType(event.target.value);
  };

  React.useEffect(() => {
    let isMounted = true;
    
    sendRequest(
      {
        url: "/corporates",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: {
          emailID: localStorage.getItem("user"),
        },
      },
      (data) => {
        if (isMounted) {
          corporateLists(data);
        }
      }
    );
    
    return () => {
      isMounted = false;
    };
  }, [sendRequest]);

  // Apply status filter when privateDrivers or statusFilter changes
  React.useEffect(() => {
    // Use a ref to track if component is mounted
    let isMounted = true;
    
    if (!privateDrivers || privateDrivers.length === 0) {
      if (isMounted) {
        setFilteredData([]);
      }
      return;
    }

    // Use useMemo-like logic to avoid creating new arrays unnecessarily
    let filtered = privateDrivers;

    // Apply status filter
    if (statusFilter === "approved") {
      filtered = privateDrivers.filter(
        (driver) => driver.isApproved === 1 || driver.isApproved === true
      );
    } else if (statusFilter === "suspended") {
      filtered = privateDrivers.filter(
        (driver) => driver.isApproved === null || driver.isApproved === 0 || driver.isApproved === false
      );
    }

    // Only update state if component is still mounted
    if (isMounted) {
      setFilteredData(filtered);
    }
    
    // Cleanup function
    return () => {
      isMounted = false;
    };
  }, [privateDrivers, statusFilter]);

  const corporateLists = (data) => {
    const tempArr =
      data?.corporates?.map((cp) => ({
        cpName: cp?.name,
        cpId: cp?.corporateID,
        dpId: cp?.departments.map((el) => el.corporateID?.[0]),
        parentID: cp?.parentID,
      })) || [];
    setCorporateData(tempArr);
  };

  const handleCorporateChange = (event, newValue) => {
    if (newValue) {
      const selectedData = corporateData?.filter(
        (data) => data?.cpName === newValue
      );
      setSelectedCorporateDetails(selectedData);
    } else {
      setSelectedCorporateDetails([]);
    }
  };

  const handleMenuClick = (event, corporate) => {
    setAnchorEl(event.currentTarget);
    setChangeVehicleDriverData(corporate);
    setDriverEmailForLocation(corporate?.emailID);
    setDriverData(corporate);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    // setSelectedCorporate(null);
    setChangeVehicleDriverData(null);
  };

  const handleApproval = async (row) => {
    const updatedStatus = row?.isApproved == 1 ? false : true; // Toggle between Approve & Reject

    sendRequest(
      {
        url: "/driverapproval",
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: {
          emailID: localStorage.getItem("user"),
          data: {
            emailID: row.emailID,
            isApproved: updatedStatus,
          },
        },
      },
      (response) => {
        let parsedResponse;
        try {
          if (typeof response === "string") {
            // If response is a string, try extracting JSON from it
            const jsonStartIndex = response.indexOf("{");
            if (jsonStartIndex !== -1) {
              parsedResponse = JSON.parse(response.substring(jsonStartIndex));
            } else {
              parsedResponse = { message: "Unexpected response format" };
            }
          } else if (typeof response === "object") {
            // If response is already an object, use it directly
            parsedResponse = response;
          } else {
            parsedResponse = { message: "Unexpected response format" };
          }
        } catch (error) {
          console.log("❌ JSON Parse Error:", error);
          parsedResponse = { message: "Unexpected response format" };
        }

        if (parsedResponse.status === 200 || parsedResponse.status === 201) {
          toast.success(
            parsedResponse.message ||
              `Driver ${updatedStatus ? "approved" : "rejected"} successfully!`
          );
          row.isApproved = updatedStatus;

          setIsApiCall(true);
          setAnchorEl(false);
        } else {
          console.log("❌ Error Response:", parsedResponse);
          toast.error(parsedResponse.message || "Unexpected error occurred.");
        }
      }
    );
  };

  return (
    <React.Fragment>
      {isAddEditPrivateDriverOperationSuccess && (
        <Snackbar
          open={isAddEditPrivateDriverOperationSuccess !== null}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          onClose={() => setIsAddEditPrivateDriverOperationSuccess(null)}
        >
          <Alert
            onClose={() => setIsAddEditPrivateDriverOperationSuccess(null)}
            severity={
              isAddEditPrivateDriverOperationSuccess ? "success" : "error"
            }
            sx={{
              width: "100%",
              backgroundColor: isAddEditPrivateDriverOperationSuccess
                ? "rgba(42, 149, 69, 255)"
                : "rgba(255, 69, 69, 255)",
            }}
          >
            {isAddEditPrivateDriverOperationSuccess
              ? `Drivers have been ${
                  opeationType === "add" ? "added" : "removed"
                } successfully`
              : "Some error occurred"}
          </Alert>
        </Snackbar>
      )}

      <Dialog open={isAddDriverClicked}>
        <DialogTitle>
          {/* {driverType === "private"
            ? "Add Private Driver"
            : "Add Shuttle Driver"} */}
          Add Driver
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Please select a driver that you want to add in{" "}
            {selectedCorporateDetails?.cpName}
          </DialogContentText>

          <FormControl style={{ width: "100%", marginTop: "16px" }}>
            <RadioGroup value={driverType} onChange={handleDriverTypeChange}>
              <div style={{ display: "flex", gap: "40%" }}>
                <FormControlLabel
                  value="private"
                  control={<Radio />}
                  label="Private"
                />

                <FormControlLabel
                  value="shuttle"
                  control={<Radio />}
                  label="Shuttle"
                />
              </div>
            </RadioGroup>
          </FormControl>

          <Autocomplete
            id="corporate-filter"
            // disabled={loading == true}

            options={
              corporateData &&
              corporateData
                ?.filter((el) => el.parentID === null)
                ?.map((data) => data?.cpName)
            }
            sx={{ width: "100%" }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="standard"
                placeholder="Search Corporate Name"
                label="Corporate Name"
              />
            )}
            onChange={(e, newValue) =>
              // corporateNameClickHandler(e, newValue)
              handleCorporateChange(e, newValue)
            }
            value={
              selectedCorporateDetails && selectedCorporateDetails.length > 0
                ? selectedCorporateDetails[0].cpName
                : ""
            } // Use selectedCorporate state if available, otherwise use the provided value prop
          />
          <Autocomplete
            // multiple
            id="tags-standard"
            options={allDriversList}
            getOptionLabel={(driver) =>
              driver.fName +
              " " +
              driver.lName +
              " - " +
              driver.vehicleModel +
              "(" +
              driver.vehicleNumber +
              ")"
            }
            onChange={(e, newValue) => driverSelectHandler(e, newValue)}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="standard"
                label="Driver Name"
                placeholder="Search Driver"
              />
            )}
          />
        </DialogContent>
        <DialogActions>
          <Button
            label="Cancel"
            size="small"
            backgroundColor="red"
            onClick={() => {
              selectedDriversEmailId = "";
              setIsAddDriverClicked(false);
            }}
          />
          <Button 
            label="Save Changes"
            size="small"
            onClick={() => setIsAddDeletePrivateDriversClicked(true)}
          />
        </DialogActions>
      </Dialog>
      {
        openedDriverQr && <QrCode openedDriverQr={openedDriverQr} />
        // </div>
      }
      <Paper
        sx={{
          width: "100%",
          mb: 2,
          borderRadius: "10px",
          flex: 1,
          display: "flex",
          flexDirection: "column",
          border: "none",
          borderBottom: "none",
        }}
      >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              px: 2,
              pt: 1,
              pb: 1,
              borderRadius: "10px",
              flexDirection: { xs: "column", md: "row" },
              gap: { xs: 1, md: 0 },
            }}
          >
            <Box component="h2" sx={{ m: 0, display: "flex", alignItems: "center" }}>
              <PortalTitle fallback="Drivers" />
            </Box>
            <Box
              sx={{
                display: "flex",
                gap: "12px",
                alignItems: "center",
                flexDirection: { xs: "column", md: "row" },
        }}
      >
          <EnhancedTableToolbar
            selected={selected}
            setIsAddDriverClicked={setIsAddDriverClicked}
            setIsDeleteDialogOpen={setIsDeleteDialogOpen}
            selectedCorporateDetails={selectedCorporateDetails}
            setSelectedCorporateDetails={setSelectedCorporateDetails}
            setDriverType={setDriverType}
            driverType={driverType}
            setIsApiCall={setIsApiCall}
            filteredCorporates={filteredCorporates}
            setFilteredCorporates={setFilteredCorporates}
            visibleRows={visibleRows}
            setFilteredData={setFilteredData}
            privateDrivers={privateDrivers}
            corporateData={corporateData}
            setCorporateData={setCorporateData}
            statusFilter={statusFilter}
            setStatusFilter={setStatusFilter}
          />
              {localStorage.getItem("roleId") == "1" && (
                <>
                  <Button
                    label="Add Driver"
                    onClick={() => setIsAddDriverClicked(true)}
                    variant="contained"
                    size="medium"
                    sx={{
                      backgroundColor: "#44B150",
                      ":hover": {
                        backgroundColor: "#44B150",
                        opacity: 0.8,
                      },
                      boxShadow: "none",
                      fontFamily: "Montserrat",
                      fontSize: "12px",
                      padding: "8px 20px",
                      textTransform: "none",
                      minWidth: "110px",
                      marginLeft: "12px",
                    }}
                  />
                  <Button
                    onClick={() =>
                      history.push({
                        pathname: "/driver-registration",
                        state: { setIsApiCall: true },
                      })
                    }
                    variant="contained"
                    size="medium"
                    sx={{
                      backgroundColor: "#44B150",
                      ":hover": {
                        backgroundColor: "#44B150",
                        opacity: 0.8,
                      },
                      boxShadow: "none",
                      fontFamily: "Montserrat",
                      fontSize: "12px",
                      padding: "8px 20px",
                      textTransform: "none",
                      minWidth: "110px",
                      marginLeft: "12px",
                    }}
                  >
                    Onboard Driver
                  </Button>
                </>
              )}
            </Box>
          </Box>
          {/* Desktop Table View */}
          <TableContainer
            component={Paper}
            sx={{
              borderRadius: "10px",
              boxShadow: "none",
              display: { xs: "none", md: "block" },
              width: "100%",
              overflowX: "hidden",
              border: "none",
              borderBottom: "none",
              "& .MuiPaper-root": {
                border: "none",
                borderBottom: "none",
              },
            }}
          >
            <Table
              sx={{
                width: "100%",
                fontFamily: "Montserrat",
                tableLayout: "fixed",
                "& .MuiTableCell-root": {
                  fontSize: "0.855rem !important",
                  padding: "8px 4px !important",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                },
              }}
              aria-labelledby="tableTitle"
              size="small"
            >
              <EnhancedTableHead
                numSelected={selected?.length}
                order={order}
                orderBy={orderBy}
                onSelectAllClick={handleSelectAllClick}
                onRequestSort={handleRequestSort}
                rowCount={privateDrivers?.length}
                selectedCorporateDetails={selectedCorporateDetails}
                driverType={driverType}
              />
              {dataLoading ? (
                <TableBody>
                  <TableRow>
                    <TableCell 
                      colSpan={localStorage.getItem("roleId") == "1" ? 10 : 8} 
                      align="center"
                      sx={{ 
                        padding: "40px !important",
                        fontFamily: "Montserrat"
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          gap: 2,
                        }}
                      >
                        <CircularProgress size={40} />
                        <Typography
                          sx={{
                            fontFamily: "Montserrat",
                            fontSize: "14px",
                            color: "#666",
                          }}
                        >
                          Loading drivers...
                        </Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                </TableBody>
              ) : (
                <TableBody>
                  {visibleRows?.map((row, index) => {
                    const isItemSelected = isSelected(row.DriverEmailID);
                    const labelId = `enhanced-table-checkbox-${index}`;

                    return (
                      <TableRow
                        hover
                        role="checkbox"
                        aria-checked={isItemSelected}
                        tabIndex={-1}
                        key={row.DriverEmailID}
                        selected={isItemSelected}
                      >
                        <TableCell padding="none">
                          {selectedCorporateDetails?.cpName &&
                            driverType !== "all" && (
                              <Checkbox
                                onClick={(event) =>
                                  handleClick(event, row.DriverEmailID)
                                }
                                color="primary"
                                size="small"
                                checked={isItemSelected}
                                inputProps={{
                                  "aria-labelledby": labelId,
                                }}
                              />
                            )}
                        </TableCell>

                        <TableCell
                          sx={{ fontFamily: "Montserrat" }}
                          id={labelId}
                          scope="row"
                          padding="none"
                          align="center"
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <img
                              src={row.DriverImage || adminAlternative}
                              style={{
                                borderRadius: "50%",
                                objectFit: "cover",
                                width: "38px",
                                height: "38px",
                                marginRight: "6px",
                              }}
                            />
                            <div style={{ minWidth: 0 }}>
                              <>
                                <p style={{ fontSize: "0.855rem", margin: "2px 0", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                  {row?.fName} {row?.lName}
                                </p>

                                <p style={{ fontSize: "0.75rem", color: "gray", margin: "2px 0", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                  {row?.emailID}
                                </p>
                                <p style={{ fontSize: "0.75rem", color: "gray", margin: "2px 0", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                  {row?.mobileNumber}
                                </p>
                              </>
                            </div>
                          </div>
                        </TableCell>
                        <TableCell
                          sx={{ fontFamily: "Montserrat", fontSize: "0.855rem !important" }}
                          align="center"
                        >
                          <>
                            {row.partnerEmailID !== null ||
                            row?.partnerEmailID !== null ? (
                              <div style={{ minWidth: 0 }}>
                                <p style={{ fontSize: "0.855rem", margin: "2px 0", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                  {row.partnerName ? row?.partnerName : "-"}
                                </p>
                                <p style={{ fontSize: "0.75rem", color: "gray", margin: "2px 0", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                  {row?.partnerEmailID}
                                </p>
                              </div>
                            ) : (
                              <div style={{ fontSize: "0.855rem" }}>-</div>
                            )}
                          </>
                        </TableCell>
                        <TableCell
                          sx={{ fontFamily: "Montserrat", fontSize: "0.855rem !important" }}
                          align="center"
                        >
                          <div style={{ alignItems: "center", minWidth: 0 }}>
                            <p style={{ fontSize: "0.855rem", margin: "2px 0", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{row.vehicleModal}</p>
                            <p style={{ fontSize: "0.75rem", color: "gray", margin: "2px 0", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                              {row.vehicleNumber}
                            </p>
                            <p style={{ fontSize: "0.75rem", color: "gray", margin: "2px 0", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                              {row.vehicleType ? row.vehicleType : "-"}
                            </p>
                          </div>
                        </TableCell>

                        <TableCell
                          sx={{ fontFamily: "Montserrat", fontSize: "0.855rem !important" }}
                          align="center"
                        >
                          <div style={{ fontSize: "0.855rem", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                            {row.corporates && row.corporates.length > 0
                              ? (() => {
                                  // Extract all unique types from the corporates array
                                  const allTypes = row.corporates.reduce(
                                    (acc, corporate) => {
                                      const typesArray = corporate.types
                                        .split(";")
                                        .map((type) => type.trim());
                                      return [...acc, ...typesArray];
                                    },
                                    []
                                  );

                                  // Get unique types
                                  const uniqueTypes = [...new Set(allTypes)];

                                  // Check for the presence of both "private" and "shuttle"
                                  if (
                                    uniqueTypes.includes("private") &&
                                    uniqueTypes.includes("shuttle")
                                  ) {
                                    return "private; shuttle";
                                  } else if (uniqueTypes.includes("private")) {
                                    return "private";
                                  } else if (uniqueTypes.includes("shuttle")) {
                                    return "shuttle";
                                  } else {
                                    return "-";
                                  }
                                })()
                              : "-"}
                          </div>
                        </TableCell>

                        <TableCell
                          sx={{ fontFamily: "Montserrat" }}
                          align="center"
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "0.75rem",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {(() => {
                              try {
                                const app = JSON.parse(row.AppDetails);
                                return (
                                  <span style={{ fontSize: "0.75rem" }}>
                                    <strong>V:</strong> {app.versionName}({app.versionCode})
                                  </span>
                                );
                              } catch {
                                return <span style={{ fontSize: "0.75rem" }}>-</span>;
                              }
                            })()}

                            {(() => {
                              try {
                                const device = JSON.parse(row.DeviceDetails);
                                return (
                                  <CustomInfoIcon
                                    style={{ marginLeft: "5px" }}
                                    message={
                                      <div style={{ fontSize: "11px" }}>
                                        <div>
                                          <strong>Device:</strong>{" "}
                                          {device.deviceName || "-"}
                                        </div>
                                        <div>
                                          <strong>Platform:</strong>{" "}
                                          {device.platform || "-"}
                                        </div>
                                        <div>
                                          <strong>Battery:</strong>{" "}
                                          {device.battery || "-"}%
                                        </div>
                                        <div>
                                          <strong>Network:</strong>{" "}
                                          {device.network || "-"}
                                        </div>
                                      </div>
                                    }
                                  />
                                );
                              } catch {
                                return null;
                              }
                            })()}
                          </div>
                        </TableCell>

                        <TableCell
                          sx={{ fontFamily: "Montserrat", fontSize: "0.855rem !important" }}
                          align="center"
                          onClick={() =>
                            window.open(
                              window.location.origin +
                                "/drivers/" +
                                // row.DriverEmailID
                                row.emailID
                            )
                          }
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <div style={{ display: "flex", gap: "3px", alignItems: "center" }}>
                              <DownloadIcon sx={{ fontSize: "1rem" }} />
                              <span style={{ fontSize: "0.855rem" }}>{`(${row.uniqueNumber})`}</span>
                            </div>
                          </div>
                        </TableCell>

                        <TableCell
                          sx={{ 
                            fontFamily: "Montserrat", 
                            fontSize: "0.855rem !important",
                            color:
                              row.isApproved === null || row.isApproved == 0
                                ? "red"
                                : "green",
                            fontWeight: "bold",
                          }}
                          align="center"
                        >
                          {row.isApproved === null || row.isApproved == 0
                            ? "Suspended"
                            : "Approved"}
                        </TableCell>

                        {localStorage.getItem("roleId") == "1" && (
                          <>
                            <TableCell
                              sx={{ fontFamily: "Montserrat", fontSize: "0.855rem !important" }}
                              align="center"
                            >
                              <div
                                style={
                                  {
                                    fontSize: "0.855rem",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    // display: "flex",
                                    // alignItems: "center",
                                  }
                                }
                              >
                                {row.corporates[0]?.name}

                                {row.corporates?.length > 1 && (
                                  <CustomInfoIcon
                                    style={{ margin: "auto" }}
                                    message={row.corporates?.map(
                                      (dep, index) => (
                                        <div
                                          key={
                                            dep?.corporateID || Math.random()
                                          }
                                        >
                                          <div
                                            style={{
                                              display: "flex",
                                              gap: "2px",
                                            }}
                                          >
                                            <div>{index + 1}.</div>
                                            <div>
                                              <div>
                                                {dep?.name ? dep?.name : "-"}
                                              </div>
                                              <div style={{ fontSize: "10px" }}>
                                                (
                                                {dep?.corporateID
                                                  ? dep?.corporateID
                                                  : "-"}
                                                )
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      )
                                    )}
                                  />
                                )}
                              </div>
                            </TableCell>

                            <TableCell 
                              sx={{ 
                                fontSize: "0.855rem !important", 
                                padding: "8px 4px !important",
                                textAlign: "center",
                              }}
                              align="center"
                            >
                              <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <IconButton
                                  onClick={(event) => handleMenuClick(event, row)}
                                  size="small"
                                  sx={{ padding: "4px" }}
                                >
                                  <MoreVertIcon sx={{ fontSize: "1.1rem" }} />
                                </IconButton>
                              </Box>
                              <Menu
                                anchorEl={anchorEl}
                                open={Boolean(anchorEl)}
                                onClose={handleMenuClose}
                                sx={{
                                  "& .MuiPaper-root": {
                                    boxShadow: "none",
                                    borderRadius: "10px",
                                    border: "1px solid #ccc",
                                  },
                                }}
                              >
                                <MenuItem onClick={handleOpenDeleteDriverModal}>
                                  <ListItemIcon>
                                    {/* <SettingsIcon fontSize="small" /> */}
                                    <DeleteIcon fontSize="small" />
                                  </ListItemIcon>
                                  <ListItemText>
                                    Remove from Corporate
                                  </ListItemText>
                                </MenuItem>
                                <MenuItem
                                  onClick={handleOpenChangeVehicleModal}
                                >
                                  <ListItemIcon>
                                    {/* <SettingsIcon fontSize="small" /> */}
                                    <EditIcon fontSize="small" />
                                  </ListItemIcon>
                                  <ListItemText>Change Vehicle</ListItemText>
                                </MenuItem>
                                <MenuItem
                                  onClick={() =>
                                    handleVerificationDocument(
                                      driverData?.emailID
                                    )
                                  }
                                >
                                  <ListItemIcon>
                                    {/* <SettingsIcon fontSize="small" /> */}
                                    <VerifiedIcon fontSize="small" />
                                  </ListItemIcon>
                                  <ListItemText>
                                    Verification Documents
                                  </ListItemText>
                                </MenuItem>

                                <MenuItem
                                  // onClick={handleOpenChangeVehicleModal}
                                  onClick={handleOpenLocation}
                                >
                                  <ListItemIcon>
                                    {/* <SettingsIcon fontSize="small" /> */}
                                    <LocationOnIcon fontSize="small" />
                                  </ListItemIcon>
                                  <ListItemText>Location History</ListItemText>
                                </MenuItem>
                                <MenuItem
                                  onClick={() => handleApproval(driverData)}
                                >
                                  <ListItemIcon>
                                    {driverData?.isApproved ? (
                                      <CancelIcon
                                        fontSize="small"
                                        style={{ color: "red" }}
                                      /> // Reject Icon in Red
                                    ) : (
                                      <CheckCircleIcon
                                        fontSize="small"
                                        style={{ color: "green" }}
                                      /> // Approve Icon in Green
                                    )}
                                  </ListItemIcon>
                                  <ListItemText
                                    primary={
                                      driverData?.isApproved
                                        ? "Suspend"
                                        : "Approve"
                                    }
                                    primaryTypographyProps={{
                                      style: {
                                        color: driverData?.isApproved
                                          ? "red"
                                          : "green",
                                        fontWeight: "bold",
                                      },
                                    }}
                                  />
                                </MenuItem>

                                {/* {localStorage.getItem("roleId") == 1 && (
                                  <MenuItem
                                    onClick={(e) =>
                                      handleVerificationDocument(e, row)
                                    }
                                  >
                                    
                                    Verification Document :{row.emailID}
                                  </MenuItem>
                                )} */}
                              </Menu>
                            </TableCell>
                          </>
                        )}
                      </TableRow>
                    );
                  })}
                  {!dataLoading && (visibleRows?.length === 0 ||
                    filteredData?.length === 0) && (
                    <TableRow>
                      <TableCell
                        sx={{ fontFamily: "Montserrat" }}
                        colSpan={localStorage.getItem("roleId") == "1" ? 10 : 8}
                        align="center"
                        sx={{ 
                          padding: "20px !important",
                          fontFamily: "Montserrat"
                        }}
                      >
                        No Data Available
                      </TableCell>
                    </TableRow>
                  )}
                  {emptyRows > 0 && (
                    <TableRow
                      style={{
                        height: 53 * emptyRows,
                      }}
                    >
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>
              )}
            </Table>
          </TableContainer>

          {/* Mobile Card View */}
          <Box
            sx={{
              display: { xs: "block", md: "none" },
              width: "100%",
            }}
          >
            {dataLoading ? (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  minHeight: "200px",
                  gap: 2,
                }}
              >
                <CircularProgress size={40} />
                <Typography
                  sx={{
                    fontFamily: "Montserrat",
                    fontSize: "14px",
                    color: "#666",
                  }}
                >
                  Loading drivers...
                </Typography>
              </Box>
            ) : visibleRows?.length === 0 ? (
              <Box
                sx={{
                  textAlign: "center",
                  padding: "40px",
                  fontFamily: "Montserrat",
                }}
              >
                <Typography>No Data Available</Typography>
              </Box>
            ) : (
              <Grid container spacing={2} sx={{ padding: "10px" }}>
                {visibleRows?.map((row, index) => {
                  const isItemSelected = isSelected(row.DriverEmailID);
                  const labelId = `mobile-card-${index}`;

                  // Get corporates info
                  const corporatesInfo =
                    row.corporates && row.corporates.length > 0
                      ? (() => {
                          const allTypes = row.corporates.reduce(
                            (acc, corporate) => {
                              const typesArray = corporate.types
                                .split(";")
                                .map((type) => type.trim());
                              return [...acc, ...typesArray];
                            },
                            []
                          );
                          const uniqueTypes = [...new Set(allTypes)];
                          if (
                            uniqueTypes.includes("private") &&
                            uniqueTypes.includes("shuttle")
                          ) {
                            return "private; shuttle";
                          } else if (uniqueTypes.includes("private")) {
                            return "private";
                          } else if (uniqueTypes.includes("shuttle")) {
                            return "shuttle";
                          }
                          return "-";
                        })()
                      : "-";

                  // Get app details
                  let appVersion = "-";
                  let deviceInfo = null;
                  try {
                    const app = JSON.parse(row.AppDetails);
                    appVersion = `Version: ${app.versionName}(${app.versionCode})`;
                  } catch {}

                  try {
                    const device = JSON.parse(row.DeviceDetails);
                    deviceInfo = device;
                  } catch {}

                  return (
                    <Grid item xs={12} key={row.DriverEmailID}>
                      <Card
                        sx={{
                          borderRadius: "10px",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                          fontFamily: "Montserrat",
                        }}
                      >
                        <CardContent>
                          {/* Checkbox and Driver Info Header */}
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "flex-start",
                              marginBottom: 2,
                            }}
                          >
                            {selectedCorporateDetails?.cpName &&
                              driverType !== "all" && (
                                <Checkbox
                                  onClick={(event) =>
                                    handleClick(event, row.DriverEmailID)
                                  }
                                  color="primary"
                                  checked={isItemSelected}
                                  inputProps={{
                                    "aria-labelledby": labelId,
                                  }}
                                  sx={{ marginTop: "-8px" }}
                                />
                              )}
                            <Box sx={{ flex: 1 }}>
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginBottom: 1,
                                }}
                              >
                                <img
                                  src={row.DriverImage || adminAlternative}
                                  style={{
                                    borderRadius: "50%",
                                    objectFit: "cover",
                                    width: "50px",
                                    height: "50px",
                                    marginRight: "10px",
                                  }}
                                  alt="Driver"
                                />
                                <Box sx={{ flex: 1 }}>
                                  <Typography
                                    variant="h6"
                                    sx={{
                                      fontWeight: "bold",
                                      fontSize: "16px",
                                      marginBottom: 0.5,
                                    }}
                                  >
                                    {row?.fName} {row?.lName}
                                  </Typography>
                                  <Typography
                                    variant="body2"
                                    sx={{ color: "gray", fontSize: "12px" }}
                                  >
                                    {row?.emailID}
                                  </Typography>
                                  <Typography
                                    variant="body2"
                                    sx={{ color: "gray", fontSize: "12px" }}
                                  >
                                    {row?.mobileNumber}
                                  </Typography>
                                </Box>
                              </Box>
                            </Box>
                          </Box>

                          <Divider sx={{ marginY: 1.5 }} />

                          {/* Partner */}
                          <Box sx={{ marginBottom: 1.5 }}>
                            <Typography
                              variant="caption"
                              sx={{
                                fontWeight: "bold",
                                color: "gray",
                                fontSize: "11px",
                                textTransform: "uppercase",
                              }}
                            >
                              Partner
                            </Typography>
                            <Typography variant="body2" sx={{ fontSize: "14px" }}>
                              {row.partnerEmailID !== null ||
                              row?.partnerEmailID !== null
                                ? (
                                    <>
                                      {row.partnerName ? row?.partnerName : "-"}
                                      <br />
                                      <span style={{ fontSize: "12px", color: "gray" }}>
                                        {row?.partnerEmailID}
                                      </span>
                                    </>
                                  )
                                : "-"}
                            </Typography>
                          </Box>

                          <Divider sx={{ marginY: 1.5 }} />

                          {/* Vehicle */}
                          <Box sx={{ marginBottom: 1.5 }}>
                            <Typography
                              variant="caption"
                              sx={{
                                fontWeight: "bold",
                                color: "gray",
                                fontSize: "11px",
                                textTransform: "uppercase",
                              }}
                            >
                              Vehicle
                            </Typography>
                            <Typography variant="body2" sx={{ fontSize: "14px" }}>
                              {row.vehicleModal}
                              <br />
                              <span style={{ fontSize: "12px", color: "gray" }}>
                                {row.vehicleNumber}
                              </span>
                              <br />
                              <span style={{ fontSize: "12px", color: "gray" }}>
                                {row.vehicleType ? row.vehicleType : "-"}
                              </span>
                            </Typography>
                          </Box>

                          <Divider sx={{ marginY: 1.5 }} />

                          {/* Driver Type */}
                          <Box sx={{ marginBottom: 1.5 }}>
                            <Typography
                              variant="caption"
                              sx={{
                                fontWeight: "bold",
                                color: "gray",
                                fontSize: "11px",
                                textTransform: "uppercase",
                              }}
                            >
                              Driver Type
                            </Typography>
                            <Typography variant="body2" sx={{ fontSize: "14px" }}>
                              {corporatesInfo}
                            </Typography>
                          </Box>

                          <Divider sx={{ marginY: 1.5 }} />

                          {/* App Details */}
                          <Box sx={{ marginBottom: 1.5 }}>
                            <Typography
                              variant="caption"
                              sx={{
                                fontWeight: "bold",
                                color: "gray",
                                fontSize: "11px",
                                textTransform: "uppercase",
                              }}
                            >
                              App Details
                            </Typography>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                flexWrap: "wrap",
                              }}
                            >
                              <Typography
                                variant="body2"
                                sx={{ fontSize: "12px" }}
                              >
                                {appVersion}
                              </Typography>
                              {deviceInfo && (
                                <CustomInfoIcon
                                  message={
                                    <div style={{ fontSize: "11px" }}>
                                      <div>
                                        <strong>Device:</strong>{" "}
                                        {deviceInfo.deviceName || "-"}
                                      </div>
                                      <div>
                                        <strong>Platform:</strong>{" "}
                                        {deviceInfo.platform || "-"}
                                      </div>
                                      <div>
                                        <strong>Battery:</strong>{" "}
                                        {deviceInfo.battery || "-"}%
                                      </div>
                                      <div>
                                        <strong>Network:</strong>{" "}
                                        {deviceInfo.network || "-"}
                                      </div>
                                    </div>
                                  }
                                />
                              )}
                            </Box>
                          </Box>

                          <Divider sx={{ marginY: 1.5 }} />

                          {/* QR Code */}
                          <Box sx={{ marginBottom: 1.5 }}>
                            <Typography
                              variant="caption"
                              sx={{
                                fontWeight: "bold",
                                color: "gray",
                                fontSize: "11px",
                                textTransform: "uppercase",
                              }}
                            >
                              QR Code
                            </Typography>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                cursor: "pointer",
                              }}
                              onClick={() =>
                                window.open(
                                  window.location.origin +
                                    "/drivers/" +
                                    row.emailID
                                )
                              }
                            >
                              <DownloadIcon fontSize="small" />
                              <Typography variant="body2" sx={{ fontSize: "14px" }}>
                                {`(${row.uniqueNumber})`}
                              </Typography>
                            </Box>
                          </Box>

                          <Divider sx={{ marginY: 1.5 }} />

                          {/* Status */}
                          <Box sx={{ marginBottom: 1.5 }}>
                            <Typography
                              variant="caption"
                              sx={{
                                fontWeight: "bold",
                                color: "gray",
                                fontSize: "11px",
                                textTransform: "uppercase",
                                marginBottom: 1,
                                display: "block",
                              }}
                            >
                              Status
                            </Typography>
                            <Chip
                              label={
                                row.isApproved === null || row.isApproved == 0
                                  ? "Suspended"
                                  : "Approved"
                              }
                              color={
                                row.isApproved === null || row.isApproved == 0
                                  ? "error"
                                  : "success"
                              }
                              size="small"
                              sx={{ fontWeight: "bold" }}
                            />
                          </Box>

                          {/* Corporates (if roleId == 1) */}
                          {localStorage.getItem("roleId") == "1" && (
                            <>
                              <Divider sx={{ marginY: 1.5 }} />
                              <Box sx={{ marginBottom: 1.5 }}>
                                <Typography
                                  variant="caption"
                                  sx={{
                                    fontWeight: "bold",
                                    color: "gray",
                                    fontSize: "11px",
                                    textTransform: "uppercase",
                                  }}
                                >
                                  Corporates
                                </Typography>
                                <Box sx={{ marginTop: 0.5 }}>
                                  {row.corporates[0]?.name && (
                                    <Typography
                                      variant="body2"
                                      sx={{ fontSize: "14px" }}
                                    >
                                      {row.corporates[0]?.name}
                                    </Typography>
                                  )}
                                  {row.corporates?.length > 1 && (
                                    <CustomInfoIcon
                                      message={row.corporates?.map(
                                        (dep, idx) => (
                                          <div
                                            key={
                                              dep?.corporateID || Math.random()
                                            }
                                          >
                                            <div
                                              style={{
                                                display: "flex",
                                                gap: "2px",
                                              }}
                                            >
                                              <div>{idx + 1}.</div>
                                              <div>
                                                <div>
                                                  {dep?.name ? dep?.name : "-"}
                                                </div>
                                                <div style={{ fontSize: "10px" }}>
                                                  ({dep?.corporateID
                                                    ? dep?.corporateID
                                                    : "-"})
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        )
                                      )}
                                    />
                                  )}
                                </Box>
                              </Box>
                            </>
                          )}

                          {/* Actions (if roleId == 1) */}
                          {localStorage.getItem("roleId") == "1" && (
                            <>
                              <Divider sx={{ marginY: 1.5 }} />
                              <Box>
                                <Typography
                                  variant="caption"
                                  sx={{
                                    fontWeight: "bold",
                                    color: "gray",
                                    fontSize: "11px",
                                    textTransform: "uppercase",
                                    marginBottom: 1,
                                    display: "block",
                                  }}
                                >
                                  Actions
                                </Typography>
                                <Box
                                  sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 1,
                                  }}
                                >
                                  <MuiButton
                                    variant="outlined"
                                    size="small"
                                    startIcon={<DeleteIcon />}
                                    onClick={(event) => {
                                      driverSelectHandler(event, row);
                                      handleMenuClick(event, row);
                                      handleOpenDeleteDriverModal();
                                    }}
                                    sx={{
                                      justifyContent: "flex-start",
                                      textTransform: "none",
                                    }}
                                  >
                                    Remove from Corporate
                                  </MuiButton>
                                  <MuiButton
                                    variant="outlined"
                                    size="small"
                                    startIcon={<EditIcon />}
                                    onClick={(event) => {
                                      // Set the driver data first, then open modal
                                      // Normalize the data structure to ensure all properties are available
                                      const driverInfo = {
                                        ...row,
                                        DriverImage: row.DriverImage || row.driverImage || row.DriverImage,
                                        fName: row.fName || (row.DriverName ? row.DriverName.split(' ')[0] : '') || '',
                                        lName: row.lName || (row.DriverName ? row.DriverName.split(' ').slice(1).join(' ') : '') || '',
                                        emailID: row.emailID || row.DriverEmailID || '',
                                        vehicleModal: row.vehicleModal || row.CarModel || '',
                                        vehicleNumber: row.vehicleNumber || row.CarNumber || '',
                                      };
                                      // Use setTimeout to ensure state is set before opening modal
                                      setChangeVehicleDriverData(driverInfo);
                                      setDriverData(driverInfo);
                                      setTimeout(() => {
                                        handleOpenChangeVehicleModal();
                                      }, 0);
                                    }}
                                    sx={{
                                      justifyContent: "flex-start",
                                      textTransform: "none",
                                    }}
                                  >
                                    Change Vehicle
                                  </MuiButton>
                                  <MuiButton
                                    variant="outlined"
                                    size="small"
                                    startIcon={<VerifiedIcon />}
                                    onClick={(event) => {
                                      driverSelectHandler(event, row);
                                      handleVerificationDocument(
                                        row?.emailID
                                      );
                                    }}
                                    sx={{
                                      justifyContent: "flex-start",
                                      textTransform: "none",
                                    }}
                                  >
                                    Verification Documents
                                  </MuiButton>
                                  <MuiButton
                                    variant="outlined"
                                    size="small"
                                    startIcon={<LocationOnIcon />}
                                    onClick={(event) => {
                                      driverSelectHandler(event, row);
                                      setDriverEmailForLocation(row?.emailID);
                                      handleOpenLocation();
                                    }}
                                    sx={{
                                      justifyContent: "flex-start",
                                      textTransform: "none",
                                    }}
                                  >
                                    Location History
                                  </MuiButton>
                                  <MuiButton
                                    variant="outlined"
                                    size="small"
                                    startIcon={
                                      row?.isApproved ? (
                                        <CancelIcon style={{ color: "red" }} />
                                      ) : (
                                        <CheckCircleIcon
                                          style={{ color: "green" }}
                                        />
                                      )
                                    }
                                    onClick={(event) => {
                                      driverSelectHandler(event, row);
                                      handleApproval(row);
                                    }}
                                    sx={{
                                      justifyContent: "flex-start",
                                      textTransform: "none",
                                      color: row?.isApproved ? "red" : "green",
                                    }}
                                  >
                                    {row?.isApproved ? "Suspend" : "Approve"}
                                  </MuiButton>
                                </Box>
                              </Box>
                            </>
                          )}
                        </CardContent>
                      </Card>
                    </Grid>
                  );
                })}
              </Grid>
            )}
          </Box>

          {/* Modal for remove driver from corporate */}
          <Modal
            open={openDeleteModal}
            // onClose={handleCloseAddTaskModal}
            onClose={(event, reason) => {
              if (reason !== "backdropClick") {
                handleCloseDeleteDriverModal();
              }
            }}
            aria-labelledby="add-new-task-modal"
            aria-describedby="add-new-task-modal-description"
          >
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                overflowX: "auto",
                transform: "translate(-50%, -50%)",
                minWidth: "350px",
                width: "30%",
                maxHeight: "80vh",
                overflowY: "auto",
                bgcolor: "background.paper",
                // bgcolor: "rgba(34, 137, 203, 255)",
                // border: "2px solid",
                zIndex: "1500",
                boxShadow: 24,
                borderRadius: 4,
                p: 3,
              }}
            >
              <Box
                sx={{
                  position: "absolute",
                  top: 8,
                  right: 8,
                  zIndex: 1,
                }}
              >
                <IconButton
                  onClick={handleCloseDeleteDriverModal}
                  sx={{
                    backgroundColor: "#d52029",
                    color: "white",
                    padding: "8px",
                    "&:hover": {
                      backgroundColor: "#b01d25",
                    },
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </Box>
              <DeleteDriver
                selectedCorporate={selectCorporateOnDelete}
                setSelectedCorporate={setSelectCorporateOnDelete}
                driverData={driverData}
                isAddDeletePrivateDrivesClicked={
                  setIsAddDeletePrivateDriversClicked
                }
                setIsDeleteDialogOpen={setIsDeleteDialogOpen}
                isDeleteDialogOpen={isDeleteDialogOpen}
                selectedDriverType={selectedDriverType}
                setSelectedDriverType={setSelectedDriverType}
                setIsApiCall={setIsApiCall}
                // getTaskList={getTaskList}
                onCloseModal={handleCloseDeleteDriverModal}
                setAnchorEl={setAnchorEl}
              />
            </Box>
          </Modal>

          {/* Modal for Change vehicle for the drivers */}
          <Modal
            open={openChangeVehicleModal}
            // onClose={handleCloseAddTaskModal}
            onClose={(event, reason) => {
              if (reason !== "backdropClick") {
                handleCloseChangeVehicleModal();
              }
            }}
            aria-labelledby="add-new-task-modal"
            aria-describedby="add-new-task-modal-description"
          >
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                overflowX: "hidden",
                transform: "translate(-50%, -50%)",
                minWidth: "350px",
                width: "30%",
                maxHeight: "80vh",
                overflowY: "auto",
                bgcolor: "background.paper",
                // bgcolor: "rgba(34, 137, 203, 255)",
                // border: "2px solid",
                zIndex: "1500",
                boxShadow: 24,
                borderRadius: 4,
                p: 3,
              }}
            >
              <Box
                sx={{
                  position: "absolute",
                  top: 8,
                  right: 8,
                  zIndex: 1,
                }}
              >
                <IconButton
                  onClick={handleCloseChangeVehicleModal}
                  sx={{
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    color: "white",
                    padding: "8px",
                    "&:hover": {
                      backgroundColor: "rgba(0, 0, 0, 0.7)",
                    },
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </Box>
              <ChangeVehicle
                driverData={changeVehicleDriverData}
                setIsApiCall={setIsApiCall}
                setAnchorEl={setAnchorEl}
                onCloseModal={handleCloseChangeVehicleModal}
              />
            </Box>
          </Modal>

          {/* Modal for Driver Locations */}

          <Modal
            open={openDriverLocation}
            onClose={(event, reason) => {
              if (reason !== "backdropClick") {
                handleCloseLocation();
              }
            }}
            aria-labelledby="add-new-task-modal"
            aria-describedby="add-new-task-modal-description"
          >
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                overflowX: "hidden",
                // overflowY: "hidden",

                transform: "translate(-50%, -50%)",
                width: "90%",
                maxHeight: "90vh",
                overflowY: "auto",
                bgcolor: "background.paper",

                zIndex: "1500",
                boxShadow: 24,
                borderRadius: 4,
                p: 3,
              }}
            >
              {/* Close button */}
              <Box
                sx={{
                  position: "absolute",
                  top: 8,
                  right: 8,
                  zIndex: 1,
                }}
              >
                <IconButton
                  onClick={handleCloseLocation}
                  sx={{
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    color: "white",
                    padding: "8px",
                    "&:hover": {
                      backgroundColor: "rgba(0, 0, 0, 0.7)",
                    },
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </Box>

              {/* Past Driver Location Component */}
              <PastDriverLocation
                emailID={driverEmailForLocation}
                setIsApiCall={setIsApiCall}
                setAnchorEl={setAnchorEl}
                onCloseModal={handleCloseLocation}
              />
            </Box>
          </Modal>

          {/* <CommonTablePagination
            page={page}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
            setPage={setPage}
            filteredData={filteredData}
            styling={{ display: "flex", justifyContent: "flex-end" }}
          /> */}
          <Box
            sx={{
              position: "sticky",
              bottom: 0,
              background: "white",
              zIndex: 1,
              border: "none !important",
              borderTop: "none !important",
              borderBottom: "none !important",
            }}
          >
            <CommonTablePagination
              page={page}
              rowsPerPage={rowsPerPage}
              setRowsPerPage={setRowsPerPage}
              setPage={setPage}
              filteredData={filteredData}
              styling={{
                display: "flex",
                justifyContent: "flex-end",
                p: 2,
                border: "none",
                borderTop: "none",
                borderBottom: "none",
                "& .MuiTablePagination-root": {
                  border: "none",
                  borderTop: "none",
                  borderBottom: "none",
                },
                "& .MuiTablePagination-toolbar": {
                  border: "none",
                  borderTop: "none",
                  borderBottom: "none",
                },
              }}
            />
          </Box>
        </Paper>
    </React.Fragment>
  );
}
